module.exports = __webpack_public_path__ + "img/desktop-VTA-valoracion-modificar01.ae0c8dcd.png";